import React, {Fragment, useState} from "react";
import InputErrorMessage from "./InputErrorMessage";

function Agreements({onChange, formValidation, checkedAgreements, hiddenAgreements = []}) {

    const agreementsTexts = [
        "Przesłanie formularza oznacza wyrażenie zgody na przetwarzanie moich danych osobowych w celu przygotowania oferty.",
        "Upoważniam GO LEASING Sp. z o.o., ul. Towarowa 9F lok.49, 10-416 Olsztyn oraz firmy współpracujące* " +
        "do pozyskania z Biur Informacji Gospodarczej oraz Kredytowej informacji niezbędnych do dokonania oceny mojej " +
        "wiarygodności płatniczej oraz oceny ryzyka kredytowego. Jestem świadomy, że wymienione dane osobowe " +
        "wykorzystane zostaną w celu pozyskania ww. informacji, niezbędnych w ramach realizacji składanego wniosku.",
        "Wyrażam zgodę na otrzymywanie informacji marketingowych za pomocą środków komunikacji elektronicznej.",
        "Wyrażam zgodę na otrzymywanie informacji marketingowych przy użyciu telekomunikacyjnych urządzeń " +
        "końcowych oraz automatycznych systemów wywołujących."];

    const [allChecked, setAllChecked] = useState(false);
    const [agreements, setAgreements] = useState({
        agreement_1: {
            value: agreementsTexts[0],
            checked: checkedAgreements.includes(agreementsTexts[0]),
            visible: !hiddenAgreements.includes(0),
            collapse: false
        },
        agreement_2: {
            value: agreementsTexts[1],
            checked: checkedAgreements.includes(agreementsTexts[1]),
            visible: !hiddenAgreements.includes(1),
            collapse: false
        },
        agreement_3: {
            value: agreementsTexts[2],
            checked: checkedAgreements.includes(agreementsTexts[2]),
            visible: !hiddenAgreements.includes(2),
            collapse: false
        },
        agreement_4: {
            value: agreementsTexts[3],
            checked: checkedAgreements.includes(agreementsTexts[3]),
            visible: !hiddenAgreements.includes(3),
            collapse: false
        }
    });

    const checkableAgreementNames = ["agreement_2", "agreement_3", "agreement_4"];

    const areAllVisibleAgreementsChecked = (updatedAgreements) =>
        checkableAgreementNames
            .filter(name => updatedAgreements[name].visible)
            .every(name => updatedAgreements[name].checked);

    const allAgreementChangeHandler = () => {
        let updatedAgreements = {...agreements};

        let checkedAgreementsList = [];
        for (const name in updatedAgreements) {
            updatedAgreements[name].checked = !allChecked;

            if (updatedAgreements[name].checked === true && updatedAgreements[name].visible) {
                checkedAgreementsList.push(updatedAgreements[name].value);
            }
        }

        setAgreements(updatedAgreements);
        setAllChecked(prevState => !prevState);

        onChange(checkedAgreementsList);
    }

    const agreementChangeHandler = (name) => {
        let updatedAgreements = {...agreements};
        let agreement = {...agreements[name]};
        agreement.checked = !agreement.checked;

        updatedAgreements[name] = agreement;
        setAgreements(updatedAgreements);
        setAllChecked(areAllVisibleAgreementsChecked(updatedAgreements));

        let checkedAgreementsList = [];
        for (const name in updatedAgreements) {
            if (updatedAgreements[name].checked === true) {
                checkedAgreementsList.push(updatedAgreements[name].value);
            }
        }

        onChange(checkedAgreementsList);
    }

    return (
        <Fragment>
            <div className="expert-help-checkboxes">
                <InputErrorMessage error={formValidation.errors.agreement_1}/>
                {agreements["agreement_1"].visible && (
                    <span className="default-agreement">
                        {agreements["agreement_1"].value}
                        &nbsp;Więcej informacji&nbsp;
                        <a href="/rodo" target="_blank" className="as-link">tutaj</a>.
                    </span>
                )}

                <label className="search-checkbox-row">
                    <input type="checkbox"
                           checked={allChecked}
                           onChange={allAgreementChangeHandler}/>
                    <strong>Zaznacz wszystkie</strong>
                </label>

                <InputErrorMessage error={formValidation.errors.agreement_2}/>
                {agreements["agreement_2"].visible && (
                    <label className="search-checkbox-row">
                        <input type="checkbox"
                               name="agreement_2"
                               ref={formValidation.register({required: true})}
                               checked={agreements["agreement_2"].checked}
                               onChange={() => agreementChangeHandler("agreement_2")}/>
                        <span><strong>*</strong> {agreements["agreement_2"].value}
                            &nbsp;Więcej informacji&nbsp;
                            <a href="/rodo" target="_blank" className="as-link">tutaj</a>.
                        </span>
                    </label>
                )}

                {agreements["agreement_3"].visible && (
                    <label className="search-checkbox-row">
                        <input type="checkbox"
                               checked={agreements["agreement_3"].checked}
                               onChange={() => agreementChangeHandler("agreement_3")}/>
                        <span>{agreements["agreement_3"].value}
                            &nbsp;Więcej informacji&nbsp;
                            <a href="/rodo" target="_blank" className="as-link">tutaj</a>.
                        </span>
                    </label>
                )}

                {agreements["agreement_4"].visible && (
                    <label className="search-checkbox-row">
                        <input type="checkbox"
                               checked={agreements["agreement_4"].checked}
                               onChange={() => agreementChangeHandler("agreement_4")}/>
                        <span>{agreements["agreement_4"].value}
                            &nbsp;Więcej informacji&nbsp;
                            <a href="/rodo" target="_blank" className="as-link">tutaj</a>.
                        </span>
                    </label>
                )}

                <div className="bp3-text-small">
                    <p>
                        Przesyłane informacje marketingowe mogą zawierać spersonalizowane komunikaty na temat oferty,
                        promocji, GO-leasing, przygotowane specjalnie dla mnie. Podając swoje dane wyrażam zgodę na
                        utworzenie spersonalizowanego profilu użytkownika, w celu dopasowania do moich potrzeb i
                        zainteresowań reklam GO-leasing w formie elektronicznej oraz drukowanej. Więcej informacji w
                        naszym&nbsp;
                        <a href="/regulamin-serwisu" target="_blank">Regulaminie świadczenia usług</a>,&nbsp;
                        <a href="/rodo" target="_blank">Informacji o Administratorze Twoich danych</a> oraz&nbsp;
                        <a href="/polityka-prywatnosci" target="_blank">Polityce prywatności</a>
                    </p>
                </div>
            </div>
        </Fragment>
    );
}

export default Agreements;
